import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["value"]
  static values = { clientId: Number, field: String, revealUrl: String, revealed: Boolean }

  toggle() {
    if (this.revealedValue) {
      this.valueTarget.textContent = "••••••••"
      this.revealedValue = false
      this.element.querySelector('[data-action]').textContent = "Show"
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.revealUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ client_id: this.clientIdValue, field: this.fieldValue })
    })
    .then(r => {
      if (!r.ok) throw new Error("Request failed")
      return r.json()
    })
    .then(data => {
      this.valueTarget.textContent = data.value
      this.revealedValue = true
      this.element.querySelector('[data-action]').textContent = "Hide"
    })
    .catch(() => {
      this.valueTarget.textContent = "Error loading"
    })
  }
}
